module.exports = "mat-card-actions{text-align:right}\n"